import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "@env/environment";
import { Observable } from 'rxjs';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  private static baseUrl: string | null = environment.apiDomain;

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.checkBaseUrl(request, next);
  }

  private static prependBaseUrl(url: string) {
    if (!BaseUrlInterceptor.baseUrl) {
      return url;
    }

    return [BaseUrlInterceptor.baseUrl?.replace(/\/$/g, ''), url.replace(/^\.?\//, '')]
      .filter(val => val)
      .join('/');
  }

  private checkBaseUrl(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.headers.has('x-intercept-test-base')) {
      return next.handle(request);
    }

    return next.handle(request.clone({ url: BaseUrlInterceptor.prependBaseUrl(request.url) }));
  }
}
